// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type PandaDocButtonDataFragment = { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined, status: Types.PandaDocStatus, externalError?: string | null | undefined };

export const PandaDocButtonDataFragmentDoc = gql`
    fragment PandaDocButtonData on PandaDoc {
  id
  externalPandaDocUrl
  status
  externalError
}
    `;